import AccountModule from '@app/store/account'
import AuthModule from '@app/store/auth'
import DeviceModule from '@app/store/device'
import KintoneHealthModule from '@app/store/kintoneHealth'
import RepairModule from '@app/store/repair'
import ScreenModule from '@app/store/screen'
import ToastModule from '@app/store/toast'
import { Store } from 'vuex'
import { getModule } from 'vuex-module-decorators'

let authModule: AuthModule
let screenModule: ScreenModule
let accountModule: AccountModule
let deviceModule: DeviceModule
let repairModule: RepairModule
let toastModule: ToastModule
let kintoneHealthModule: KintoneHealthModule

function initialiseStores(store: Store<any>): void {
  authModule = getModule(AuthModule, store)
  screenModule = getModule(ScreenModule, store)
  accountModule = getModule(AccountModule, store)
  deviceModule = getModule(DeviceModule, store)
  repairModule = getModule(RepairModule, store)
  toastModule = getModule(ToastModule, store)
  kintoneHealthModule = getModule(KintoneHealthModule, store)
}

export {
  initialiseStores,
  authModule,
  screenModule,
  accountModule,
  deviceModule,
  repairModule,
  toastModule,
  kintoneHealthModule,
}
